import { OptionalCampaignDto } from "@apiModels/BookingSteps/OptionalCampaignDto.csharp";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { ServiceContainerDto } from "@apiModels/ServiceContainerDto.csharp";
import React, { FC } from "react";
import { FourthStepInfoContainer } from "../FormElements";
import {RichTextArea} from "../RichTextArea/RichTextArea";

interface OptionalCampaignProps {
  optionalCampaign?: OptionalCampaignDto;
  service: ServiceContainerDto;
  center: LocationDto;
}

export const OptionalCampaign: FC<OptionalCampaignProps> = ({
  optionalCampaign,
  service,
  center,
}) => {
  const shouldShow =
    !!optionalCampaign &&
    !!optionalCampaign.body &&
    !service.disableOptionalCampaignHighlight &&
    !optionalCampaign.disabledCenters.some((c) => c == center.id);

  if (!shouldShow) {
    return null;
  }

  return (
    <FourthStepInfoContainer title={optionalCampaign.heading} className="OptionalCampaign">
      <RichTextArea content={optionalCampaign.body}/>

      {optionalCampaign.link &&
        <a href={optionalCampaign.link.url} className="OptionalCampaign__link">
          {optionalCampaign.link.title}
        </a>
      }
    </FourthStepInfoContainer>
  );
};
